export default {
      id: "building-with-annex-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#building-with-annex",
      toString: function () {
        return this.url;
      }
    }